<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.screen_hardware_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    [sbRouterLink]="util.RoutingID.screenHardwareCreate"
    [queryParams]="{returnTo: util.getPageLink()}"
    sbTooltip="{{ 'lang.devices.createScreenHardware' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

  Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.screenHardware' | translate}}"
  [itemsData]="screenHardware"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'screenHardware'">

  <!------------------------------

  Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

  Table Header

------------------------------->

  <ng-template #thead>
    <tr>
      <th>ID</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.description' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.manufacturer' | translate }}</th>
      <th>{{ 'lang.globals.playerHardware' | translate }}</th>
      <th>{{ 'lang.globals.resolution' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.diagonal' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.width' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.height' | translate }}</th>
      <th class="sticky-col last-col tw-z-20">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <ng-template #tCardHead>
    <tr>
      <th>ID</th>
      <th>{{ 'lang.globals.name' | translate }}</th>
      <th>{{ 'lang.globals.description' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.manufacturer' | translate }}</th>
      <th>{{ 'lang.globals.playerHardware' | translate }}</th>
      <th>{{ 'lang.globals.resolution' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.diagonal' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.width' | translate }}</th>
      <th>{{ 'lang.devices.editScreenHardware.height' | translate }}</th>
      <th class="!tw-w-auto"><!-- empty header for minimal header with on the others --></th>
    </tr>
  </ng-template>

  <!------------------------------

  Table Body

------------------------------->

  <ng-template #tbody let-screen>
    <tr>
      <td>{{ screen.id }}</td>
      <td>
        <sb-comp-link
          [title]="screen?.name"
          [condition]="!screen.global"
          [link]="util.RoutingID.screenHardwareEdit"
          [queryParams]="{returnTo: util.getPageLink()}"
          [permission]="permissionService.Permission.screen_hardware_edit"
          [pathParams]="[{id: 'screenHardwareID', value: screen?.id }]"
          [tooltip]="'lang.globals.edit' | translate">
        </sb-comp-link>
      </td>
      <td>
        <span [innerHTML]="screen.description | truncate : 40"></span>
      </td>
      <td>
        <sb-comp-link
          [title]="screen?.manufacturer?.name"
          [link]="util.RoutingID.companyDetails"
          [permission]="permissionService.Permission.company_show"
          [queryParams]="{returnTo: util.getPageLink()}"
          [pathParams]="[{id: 'companyID', value: screen?.manufacturer?.id }]"
          [tooltip]="'lang.devices.editDeviceHardware.manufacturerDetails' | translate">
        </sb-comp-link>
      </td>
      <td>
        <sb-comp-link
          [title]="screen?.mountedTo?.name"
          [link]="util.RoutingID.playerHardwareOverview"
          [permission]="permissionService.Permission.player_hardware_show"
          [queryParams]="{returnTo: util.getPageLink()}"
          [pathParams]="[{id: 'playerHardwareID', value: screen?.mountedTo?.id }]"
          [tooltip]="'lang.devices.editScreenHardware.playerHardwareDetails' | translate">
        </sb-comp-link>
      </td>
      <td>
        {{ screen?.nativeResolution?.id }}
      </td>
      <td>{{ screen?.diagonal }}</td>
      <td>
        {{ screen?.width ? screen.width : '0' }}
      </td>
      <td>
        {{ screen?.height ? screen.height : '0' }}
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext) {
          <sb-split-button
            [splitButtonItems]="screen.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(screen, $event)"
          ></sb-split-button>
        } @else {
          <button sb-button-secondary
                  type="button"
                  ngbTooltip="{{'lang.globals.select' | translate}}"
                  (click)="selectScreenHardware(screen)"
                  [icon]="'boxChecked'"
                  [color]="'blue'"
                  [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

     Card Element

 ------------------------------->

  <ng-template #card let-screen>
    <sb-table-card class="tw-rounded-xl">
      <div table-card-header class="tw-flex tw-gap-3">
      </div>
      <div table-card-header-more>
        <sb-split-button
          [splitButtonItems]="screen.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(screen, $event)"
        ></sb-split-button>
      </div>
      <div table-card-img>
        <div class="tw-bg-[url(assets/img/devicedetails-bg.jpg)] tw-bg-cover tw-bg-center tw-h-full">
        </div>
      </div>
      <div table-card-body>
        <div
          class="sm:tw-grid sm:tw-grid-cols-4 tw-flex tw-flex-col tw-text-sbGray-800 *:sm:tw-col-span-2 *:tw-w-full *:tw-border-0 *:tw-border-b *:tw-border-solid *:tw-border-sbGray-200 *:tw-py-3.5 *:sm:tw-py-5">
          <sb-table-card-element
            [orientation]="'left'" [headline]="'lang.globals.id' | translate">
            <sb-comp-name-wrapper>
              <span firstLine>{{ screen.id }}</span>
            </sb-comp-name-wrapper>
          </sb-table-card-element>
          <sb-table-card-element [headline]="'lang.globals.name' | translate " [orientation]="'right'"
                                 [classes]="'tw-gap-2'">
            <sb-comp-link
              [title]="screen?.name"
              [condition]="!screen.global"
              [link]="util.RoutingID.screenHardwareEdit"
              [queryParams]="{returnTo: util.getPageLink()}"
              [permission]="permissionService.Permission.screen_hardware_edit"
              [pathParams]="[{id: 'screenHardwareID', value: screen?.id }]"
              [tooltip]="'lang.globals.edit' | translate">
            </sb-comp-link>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-4" [headline]="'lang.globals.description' | translate " [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <span [innerHTML]="screen?.description ? (screen?.description | truncate : 50) : '-'"></span>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-4" [headline]="'lang.devices.editScreenHardware.manufacturer' | translate "
                                 [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <sb-comp-link
              [title]="screen?.manufacturer?.name"
              [link]="util.RoutingID.companyDetails"
              [permission]="permissionService.Permission.company_show"
              [queryParams]="{returnTo: util.getPageLink()}"
              [pathParams]="[{id: 'companyID', value: screen?.manufacturer?.id }]"
              [tooltip]="'lang.devices.editDeviceHardware.manufacturerDetails' | translate">
            </sb-comp-link>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-col-span-4" [headline]="'lang.globals.playerHardware' | translate " [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <sb-comp-link
              [title]="screen?.mountedTo?.name"
              [link]="util.RoutingID.playerHardwareOverview"
              [permission]="permissionService.Permission.player_hardware_show"
              [queryParams]="{returnTo: util.getPageLink()}"
              [pathParams]="[{id: 'playerHardwareID', value: screen?.mountedTo?.id }]"
              [tooltip]="'lang.devices.editScreenHardware.playerHardwareDetails' | translate">
            </sb-comp-link>
          </sb-table-card-element>
          <sb-table-card-element [headline]="'lang.globals.resolution' | translate " [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <span>{{ screen?.nativeResolution?.id ? screen?.nativeResolution?.id : '-' }}</span>
          </sb-table-card-element>
          <sb-table-card-element [headline]="'lang.devices.editScreenHardware.diagonal' | translate " [orientation]="'right'"
                                 [classes]="'tw-gap-2'">
            <span>{{ screen?.diagonal ? screen.diagonal : '-' }}</span>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-border-0" [headline]="'lang.devices.editScreenHardware.width' | translate "
                                 [orientation]="'left'"
                                 [classes]="'tw-gap-2'">
            <span>{{ screen?.width ? screen.width : '0' }}</span>
          </sb-table-card-element>
          <sb-table-card-element class="!tw-border-0" [headline]="'lang.devices.editScreenHardware.height' | translate "
                                 [orientation]="'right'"
                                 [classes]="'tw-gap-2'">
            <span>{{ screen?.height ? screen.height : '0' }}</span>
          </sb-table-card-element>
        </div>
      </div>
    </sb-table-card>
  </ng-template>

</sb-table-wrapper-new>
